/*
 * Mobile - PDP - Sticky Cta V2  --  variant: Button With Price, Image and Name
 * Moonshot experiment id: 17183716   status in Moonshot on 2026-08-27: DEPLOYED   started: 2026-02-16
 * Audience: MOBILE   Target: pdp   (see MGExp.targets in mg-exp-runtime.js)
 * Source: verbatim variant code from cdn.moonshot-ai.com/snippets/36780565.js (prettified);
 *         only change is window.msaiTools._msaiRunVariantBlock -> MGExp.runVariantBlock.
 * Enabled by theme setting: mgexp_pdp_m_sticky_cta_v2
 */
MGExp.run('pdp_m_sticky_cta_v2', { name: "Mobile - PDP - Sticky Cta V2 / Button With Price, Image and Name", platform: 'mobile', target: 'pdp' }, function () {
  !(function () {
    let t = [],
      n = [];
    !(async function (e, i, a, c, s) {
      let o = {
        multi_target_selectors: t,
        page_identifier_selector: "section.prod-page",
        exclude_from_timeout: n,
        selector_timeout: 5e3,
      };
      await MGExp.runVariantBlock(e, i, a, c, s, o);
    })(
      [
        "#product-footer-sticky",
        "#product-footer-sticky .product-sticky-image",
        "#product-footer-sticky .title",
        "#product-footer-sticky .price",
        "#product-footer-sticky form",
      ],
      ".msai-sticky-cta-v2",
      function (t, n) {
        const [e, i, a, c, s] = n,
          o = i && i.getAttribute("src") ? i.getAttribute("src") : "",
          r = i && i.getAttribute("alt") ? i.getAttribute("alt") : "",
          d = a ? a.textContent.trim() : "",
          p = c.textContent.trim() || "",
          m = document.querySelector("#pdp-add-to-cart"),
          l = m ? m.textContent.trim().toUpperCase() : "ADD TO CART";
        (Array.from(e.children).forEach(function (t) {
          t.style.display = "none";
        }),
          e.classList.add("msai-sticky-cta-bar", "msai-sticky-cta-v2"));
        const u = document.createElement("div");
        if (((u.className = "msai-sticky-cta-inner"), d || o)) {
          const t = document.createElement("div");
          if (((t.className = "msai-sticky-cta-title-box"), o)) {
            const n = document.createElement("img");
            ((n.className = "msai-sticky-cta-thumb"),
              (n.src = o),
              (n.alt = r || d || ""),
              t.appendChild(n));
          }
          if (d) {
            const n = document.createElement("div");
            ((n.className = "msai-sticky-cta-title"),
              (n.textContent = d),
              t.appendChild(n));
          }
          u.appendChild(t);
        }
        const f = document.createElement("div");
        f.className = "msai-sticky-cta-button-wrap";
        const y = document.createElement("button");
        ((y.type = "button"),
          (y.className = "msai-sticky-cta-button"),
          (y.id = "sv6-cta"));
        const k = document.createElement("span");
        k.textContent = l;
        const b = document.createElement("span");
        b.className = "msai-sticky-cta-dot";
        const x = document.createElement("span");
        ((x.className = "msai-sticky-cta-price"),
          (x.textContent = p),
          y.appendChild(k),
          y.appendChild(b),
          y.appendChild(x),
          y.addEventListener("click", function () {
            s && s.submit();
          }),
          f.appendChild(y),
          u.appendChild(f),
          e.appendChild(u));
      },
      "\n  #product-footer-sticky.msai-sticky-cta-bar {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 9999;\n    background: transparent;\n    box-shadow: none;\n    padding: 0;\n  }\n\n  #product-footer-sticky.msai-sticky-cta-bar .msai-sticky-cta-inner {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    padding: 0 20px 10px;\n    border: 1px solid #e0e0e0;\n    background: #fff;\n  }\n\n  #product-footer-sticky.msai-sticky-cta-bar .msai-sticky-cta-title-box {\n    width: 100%;\n    box-sizing: border-box;\n    background: #fff;\n    padding: 12px 0;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n  }\n\n  #product-footer-sticky.msai-sticky-cta-bar .msai-sticky-cta-thumb {\n    width: 48px;\n    height: 48px;\n    flex-shrink: 0;\n    object-fit: cover;\n    border-radius: 4px;\n    display: block;\n  }\n\n  #product-footer-sticky.msai-sticky-cta-bar .msai-sticky-cta-title {\n    color: #1a1a1a;\n    font-family: Playfair Display, sans-serif;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 1.3;\n    margin: 0;\n    min-width: 0;\n    flex: 1;\n  }\n\n  #product-footer-sticky.msai-sticky-cta-bar .msai-sticky-cta-button-wrap {\n    width: 100%;\n    background: #1a1a1a;\n  }\n\n  #product-footer-sticky.msai-sticky-cta-bar .msai-sticky-cta-button {\n    width: 100%;\n    background: #1a1a1a;\n    color: #fff;\n    border: none;\n    padding: 0;\n    height: 56px;\n    cursor: pointer;\n    font-family: Raleway, sans-serif;\n    font-size: 18px;\n    font-weight: 800;\n    letter-spacing: 0.6px;\n    text-transform: uppercase;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0;\n  }\n\n  #product-footer-sticky.msai-sticky-cta-bar .msai-sticky-cta-dot {\n    width: 5px;\n    height: 5px;\n    border-radius: 50%;\n    background: #6b6b6b;\n    display: inline-block;\n    margin: 0 12px;\n    flex-shrink: 0;\n  }\n\n  #product-footer-sticky.msai-sticky-cta-bar .msai-sticky-cta-price {\n    font-size: 21px;\n    padding-bottom: 2px;\n  }\n\n  #chat-button {\n    z-index: 999 !important;\n  }\n",
    );
  })();
});
